import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { SearchResult } from '../../api/models/search-result';
import { SearchFacetValue } from '../../api/models/search-facet-value';
import { SearchEventPublisher } from '../../shared/service/search-event-publisher.service';
import { SearchEventTypeEnum } from '../../shared/model/search-event-type-enum';
import { AnalyticsService } from '../../shared/service/analytics/analytics.service';
import { FacetDataHolderService } from '../../shared/service/facet-data-holder.service';
import { FacetData } from '../../api/models/facet-data';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@Component({
  selector: 'app-search-filter-box',
  templateUrl: './search-filter-box.component.html',
  styleUrls: ['./search-filter-box.component.scss'],
})
@UntilDestroy()
export class SearchFilterBoxComponent implements OnInit, OnChanges {
  @Input()
  searchResult?: SearchResult;

  filters: Array<SearchFacetValue> = [];
  clearFilters: SearchFacetValue | undefined;
  facetData?: FacetData;

  constructor(private searchEventPublisher: SearchEventPublisher, private analyticsService: AnalyticsService, private facetDataHolder: FacetDataHolderService) {
  }

  ngOnInit() {
    this.facetDataHolder.getFacetData()
      .pipe(untilDestroyed(this))
      .subscribe(fd => this.facetData = fd);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['searchResult'] && this.searchResult && this.searchResult.searchResultList) {
      this.getFilters();
    }
  }

  getFilters() {
    this.filters = [];
    if (this.searchResult?.narrowByFacets?.filteredResultsFacetValue) {
      this.filters.push(this.searchResult?.narrowByFacets?.filteredResultsFacetValue);
    }
    this.searchResult?.narrowByFacets?.narrowByFacets?.forEach(item => {
      item.facetValues?.forEach(element => {
        if (element.selected) {
          this.filters.push(element);
        }
      });
    });
    this.clearFilters = this.searchResult?.narrowByFacets?.clearAllFacetValue;
  }

  deleteFilterItem(facet: SearchFacetValue) {
    facet.selected = false;
    this.searchEventPublisher.publishEvent(SearchEventTypeEnum.NARROW_BY_FACET, facet.params);
    this.analyticsService.trackNavigationChange(facet.params.sn, this.facetData?.facetCodeNameMap, this.facetData?.facetValueCodeNameMap, undefined);
  }
}
